import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegionSelectorComponent } from './region-selector.component';
import { MatSelectModule } from '@angular/material/select';
import { ReactiveFormsModule } from '@angular/forms';
import { TitleCaseAndCleanPipeModule } from '@fleet/pipes';
import { MatFormFieldModule } from '@angular/material/form-field';

@NgModule({
  declarations: [RegionSelectorComponent],
  imports: [
    CommonModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatFormFieldModule,
  ],
  exports: [RegionSelectorComponent],
})
export class RegionSelectorModule {}
